import { render, staticRenderFns } from "./DealerAbout.vue?vue&type=template&id=634645b3&scoped=true&"
import script from "./DealerAbout.vue?vue&type=script&lang=js&"
export * from "./DealerAbout.vue?vue&type=script&lang=js&"
import style0 from "./DealerAbout.vue?vue&type=style&index=0&id=634645b3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634645b3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer})
